import { ApiError } from "../errors.js";
import { InventoryClient } from "./inventory.js";
import { ClientBase } from "./base.js";
export class InspectionsClient extends InventoryClient {
    async listInspectionTemplates(slug, assetClass) {
        const res = await this.request("GET", `${this.siteBase(slug)}/inspection-templates${ClientBase.query({ assetClass })}`, undefined, true);
        return res.templates;
    }
    /** Each PUT writes a new immutable template version for (assetClass, phase). */
    async putInspectionTemplate(slug, assetClass, phase, input) {
        return this.request("PUT", `${this.siteBase(slug)}/inspection-templates/${encodeURIComponent(assetClass)}/${encodeURIComponent(phase)}`, input, true);
    }
    async submitInspection(slug, input) {
        return this.request("POST", `${this.siteBase(slug)}/inspections`, input, true);
    }
    /** Audit trail of one subject (e.g. `inspection_report`, `repair_order`), oldest first. */
    async getHistory(slug, subjectType, subjectId) {
        const res = await this.request("GET", `${this.siteBase(slug)}/history${ClientBase.query({ subjectType, subjectId })}`, undefined, true);
        return res.history;
    }
    async listInspections(slug, params = {}) {
        const res = await this.request("GET", `${this.siteBase(slug)}/inspections${ClientBase.query(params)}`, undefined, true);
        return res.reports;
    }
    async getInspection(slug, id) {
        return this.request("GET", `${this.siteBase(slug)}/inspections/${encodeURIComponent(id)}`, undefined, true);
    }
    /** Resolves with `{allowed:true}`; rejects with ApiError 422 `inspection_required` otherwise. */
    async checkInspectionGate(slug, input) {
        return this.request("POST", `${this.siteBase(slug)}/inspections/gate-check`, input, true);
    }
    async getInspectionPrice(slug, id, params) {
        return this.request("GET", `${this.siteBase(slug)}/inspections/${encodeURIComponent(id)}/price${ClientBase.query(params)}`, undefined, true);
    }
    // Technician commissions (#789)
    async listTechnicianCommissionPlans(slug) {
        const res = await this.request("GET", `${this.siteBase(slug)}/technician-commissions/plans`, undefined, true);
        return res.plans;
    }
    async setTechnicianCommissionPlan(slug, staffId, input) {
        return this.request("PUT", `${this.siteBase(slug)}/technician-commissions/plans/${encodeURIComponent(staffId)}`, input, true);
    }
    async completeTechnicianJob(slug, jobId, input) {
        const res = await this.request("POST", `${this.siteBase(slug)}/technician-commissions/jobs/${encodeURIComponent(jobId)}/complete`, input, true);
        return res.entries;
    }
    async adjustTechnicianCommission(slug, input) {
        return this.request("POST", `${this.siteBase(slug)}/technician-commissions/adjustments`, input, true);
    }
    async getTechnicianCommissionReport(slug, params) {
        const res = await this.request("GET", `${this.siteBase(slug)}/technician-commissions/report${ClientBase.query({ from: params.from, to: params.to, staffId: params.staffId })}`, undefined, true);
        return res.statements;
    }
    /** Same report as CSV text (`format=csv`). */
    async downloadTechnicianCommissionCsv(slug, params, retried401 = false) {
        const path = `${this.siteBase(slug)}/technician-commissions/report${ClientBase.query({ from: params.from, to: params.to, staffId: params.staffId, format: "csv" })}`;
        const headers = {};
        const token = this.getAccessToken();
        if (token)
            headers["Authorization"] = `Bearer ${token}`;
        const res = await this.fetchImpl(`${this.baseUrl}${path}`, { method: "GET", headers });
        const text = await res.text();
        if (!res.ok) {
            let err = {};
            try {
                err = text ? JSON.parse(text) : {};
            }
            catch {
                err = {};
            }
            if (res.status === 401 && !retried401) {
                try {
                    await this.ensureRefreshed();
                }
                catch {
                    this.setTokens(null);
                    this.onUnauthorized?.();
                    throw new ApiError(res.status, err.code ?? "error", err.error ?? res.statusText);
                }
                return this.downloadTechnicianCommissionCsv(slug, params, true);
            }
            throw new ApiError(res.status, err.code ?? "error", err.error ?? res.statusText);
        }
        return text;
    }
}
//# sourceMappingURL=inspections.js.map